export default {
  // 混淆配置：打乱字符集可以增加猜测难度
  _CHARS: 'd7p2qL5R9s1tUvW8xYzaB0cDeFgHiJk6mNoPq3rS4tUuVwXyZgjklMnObA',
  _SALT: 12345, // 偏移量
  _PRIME: 7,    // 质数系数

  // 判断当前路由是否有特定标识
  routeMatchedMeta (route, metaField) {
    if (route.matched && route.matched.length) {
      return route.matched.some(match => match.meta[metaField])
    }
    return false
  },

  /**
   * 混淆加密：ID 转 5-9位随机字符串
   */
  jiami (id) {
    try {
      if (id === null || id === undefined || id === '') return ''
      let num = parseInt(id)
      if (isNaN(num)) return id

      // 1. 数学位移混淆，让连续的 ID 生成不连续的结果
      let offsetNum = (num + this._SALT) * this._PRIME

      // 2. 转为 Base62 字符串 (包含字母和数字)
      let result = ''
      const base = this._CHARS.length
      while (offsetNum > 0) {
        result = this._CHARS[offsetNum % base] + result
        offsetNum = Math.floor(offsetNum / base)
      }

      // 3. 长度处理：确保最少 5 位，最多 9 位
      // 使用第一个字符作为“长度指示器”
      if (result.length < 5) {
        const diff = 5 - result.length
        // 选取一个字符记录补位长度
        const padIndicator = this._CHARS[diff + 10] 
        result = padIndicator + result
        // 剩余位用随机字符补齐
        while (result.length < 5) {
          result += this._CHARS[Math.floor(Math.random() * base)]
        }
      } else {
        // 如果原本就够长，头部加个 '0' 占位，表示无需特殊处理
        result = this._CHARS[0] + result
      }

      return result.slice(0, 9) // 强制截断到最高 9 位
    } catch (error) {
      console.error('混淆失败:', error)
      return id
    }
  },

  /**
   * 混淆解密：还原回原始 ID
   */
  jiemi (obfuscated) {
    try {
      if (!obfuscated) return ''
      const obfuscatedStr = String(obfuscated)
      const base = this._CHARS.length

      // 1. 获取第一个占位符判断补位情况
      const firstChar = obfuscatedStr[0]
      let realBase62Str = ''

      if (firstChar === this._CHARS[0]) {
        // 无补位情况
        realBase62Str = obfuscatedStr.slice(1)
      } else {
        // 有补位情况，根据指示器还原核心内容
        const padLen = this._CHARS.indexOf(firstChar) - 10
        // 加密逻辑是 [占位符][核心][随机]，所以核心在中间
        realBase62Str = obfuscatedStr.substring(1, obfuscatedStr.length - padLen + 1)
      }

      // 2. Base62 还原为数字
      let num = 0
      for (let i = 0; i < realBase62Str.length; i++) {
        const charIndex = this._CHARS.indexOf(realBase62Str[i])
        if (charIndex === -1) throw new Error('非法字符')
        num = num * base + charIndex
      }

      // 3. 逆向数学运算还原 ID
      const id = (num / this._PRIME) - this._SALT
      return Math.round(id)
    } catch (error) {
      console.error('反混淆失败:', error)
      return obfuscated
    }
  }
}